<!--  -->
<template>
   <el-row>
                    <el-col :span="2">
                      <div class="grid-content">H：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input              
                        ref="IsoscelesTrapezoidChildInput1"
                        @keyup.enter.native="focusNextChild('IsoscelesTrapezoidChildInput2')"  v-model="param.H" @focus="handleChildFocus"   @change="ChangData" placeholder="请输入参数H"></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">W：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input              
                        ref="IsoscelesTrapezoidChildInput2"
                        @keyup.enter.native="focusNextChild('IsoscelesTrapezoidChildInput3')" v-model="param.W" @focus="handleChildFocus"   @change="ChangData" placeholder="请输入参数W"></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">W1：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input              
                        ref="IsoscelesTrapezoidChildInput3"
                        @keyup.enter.native="focusNextChild('IsoscelesTrapezoidChildInput1')" v-model="param.W1" @focus="handleChildFocus"   @change="ChangData" placeholder="请输入参数W1"></el-input>
                      </div>
                    </el-col>
  </el-row>
</template>

<script>
export default {
    name: "IsoscelesTrapezoid",
  props: {},
  data () {
    return {
      param:{
        shapeName:"IsoscelesTrapezoid",
      H:0,
      W:0,
      W1:0,
    }
    };
  },
  methods:{
    ChangData(){
      //console.log('The message is changed.',this.param);
      this.$emit("sedX",this.param)
    },
     // 处理焦点事件，选中文本并触发父组件监听
  handleChildFocus(event) {
    //console.log("handleChildFocus");
    setTimeout(() => {
        event.target.select();
      }, 0);
     // this.$emit('focused',event); // 通知父组件输入框被聚焦了。
    },
    focusNextChild(nextInputRef) {
      console.log("nextInputRef==",nextInputRef);
      this.$nextTick(() => {
        this.$refs[nextInputRef].focus(); // 使用Vue的$refs来聚焦到下一个输入框
      });
    },
  }
}

</script>
<style lang='scss' scoped>
</style>